import React, { useState } from "react";
import ChatContextProvider from "../../../contexts/ChatContext";
import ChatContent from "../../Chat/ChatContent";
import Loader from "../../../components/LoaderCircle";
import styles from './GameChat.module.sass'

const GameChat = ({gameKey}) => {

    const [ isLoading, setIsLoading ] = useState( false );

    function onLoadingStateChange( newIsLoading ){
        setIsLoading( newIsLoading );
    }

    return (
        <div className={styles.container}>
            <ChatContextProvider isLoadingCallback={onLoadingStateChange} roomKeys={gameKey} isPersistent={false}>
                { isLoading && <Loader/> }
                <ChatContent/>
            </ChatContextProvider>
        </div>
    )

};

export default GameChat;